import ActivityACHPage from "components/pages/ActivityACHPage";

/**
 * @function CaptureACHApprovalsActivity
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @description Component in the MABI23 "Approvals" capture group.
 */
export default function CaptureACHApprovalsActivity() {
    return <ActivityACHPage />
}